import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { FaRegHandPointRight } from "react-icons/fa";
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import { CgChanel } from 'react-icons/cg'
import { addDataAPI } from '../../utils/api';
import ContentWrapper from '../../components/contentwrapper/ContentWrapper';


const AddChanel = () => {
    const navigate = useNavigate();
    const [values, setUserValue] = useState({});
    const [validated, setValidated] = useState(false);

    const subadminid = localStorage.getItem('subadmindata');
    
    useEffect(() => {
        if (subadminid) {
            navigate('/add-subadmin-chanel');
        }
        else {
            navigate("/");
        }
    }, [subadminid]);

    const handleInputs = async (e) => {
        setUserValue({
            ...values,
            [e.target.name]: e.target.value,
        });
    };
    const handleAddChanel = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
        }
        else {
            const datavalue = {
                chanel_name:values?.chanel_name,
                subadmin_id:subadminid,
            };
            addDataAPI('sub-admin-add-chanel', datavalue).then((res) => {
                if (res.data.status === 1) {
                    navigate("/all-subadmin-chanel");
                    toast.success("Chanel has been added successfully!!")
                }
                else if (res.data.status === 2) {
                    toast.warning("Chanel already Exit!!")
                }
                else {
                    toast.warning("Check your connection!!");
                }
            })
        }
        setValidated(true);
    }
    return (
        <div className="addCompany">
            <Helmet>
                <title>SATKARTAR:SUB ADMIN::ADD CHANEL</title>
            </Helmet>

            <ContentWrapper>
                <div className="col-xl-6">
                    <div className="card border-top border-0 border-4 border-danger">
                        <div className="card-body formbody">
                            <div className="card-title d-flex align-items-center">
                                <div>
                                    <CgChanel className="formIcons" />
                                </div>
                                <h5 className="mb-0 text-danger">ADD Chanel</h5>
                            </div>
                            <hr />
                            <Form noValidate validated={validated} method="POST" onSubmit={handleAddChanel}>
                                <Row className="mb-3">
                                    <Form.Group as={Col} md="12" controlId="validationChanelName">
                                        <Form.Label>Chanel Name</Form.Label>
                                        <InputGroup hasValidation>
                                            <InputGroup.Text id="inputGroupPrepend"><CgChanel /></InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                placeholder="Chanel Name"
                                                aria-describedby="inputGroupPrepend"
                                                required
                                                name="chanel_name"
                                                onChange={handleInputs}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                <FaRegHandPointRight /> Please provide a valid chanel name.
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                    
                                </Row>
                                <Button type="submit">Add</Button>
                            </Form>
                        </div>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    )
}

export default AddChanel